"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLineParsedRequest = exports.transformLineParsedResponse = exports.LineType = void 0;
const Date_1 = require("./Date");
var LineType;
(function (LineType) {
    LineType[LineType["normal"] = 0] = "normal";
    LineType[LineType["billing"] = 1] = "billing";
})(LineType = exports.LineType || (exports.LineType = {}));
function transformLineParsedResponse(line) {
    return {
        amount: line.amount,
        compoundedTax: line.compounded_tax,
        date: line.date && (0, Date_1.transformDateResponse)(line.date, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        description: line.description,
        expenseId: line.expenseid,
        invoiceId: line.invoiceid,
        lineId: line.lineid,
        creditId: line.creditid,
        name: line.name,
        qty: line.qty,
        retainerId: line.retainer_id,
        retainerPeriodId: line.retainer_period_id,
        taxName1: line.taxName1,
        taxAmount1: line.taxAmount1,
        taxName2: line.taxName2,
        taxAmount2: line.taxAmount2,
        taxNumber1: line.taxNumber1,
        taxNumber2: line.taxNumber2,
        type: line.type,
        unitCost: line.unit_cost,
        updated: line.updated && (0, Date_1.transformDateResponse)(line.updated, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
    };
}
exports.transformLineParsedResponse = transformLineParsedResponse;
function transformLineParsedRequest(line) {
    return {
        compounded_tax: line.compoundedTax,
        type: line.type,
        description: line.description,
        expenseid: line.expenseId,
        invoiceid: line.invoiceId,
        name: line.name,
        qty: line.qty,
        taxName1: line.taxName1,
        taxAmount1: line.taxAmount1,
        taxName2: line.taxName2,
        taxAmount2: line.taxAmount2,
        unit_cost: line.unitCost,
    };
}
exports.transformLineParsedRequest = transformLineParsedRequest;
//# sourceMappingURL=Line.js.map